<swap-modal [modalId]="modalId" [centered]="true">
  <div class="row m-3">
    <div class="col-12 mb-2">
      <img
        loading="lazy"
        src="assets/icons/success-with-inner-circle.svg"
        alt=""
      />
    </div>
    <div class="col-12 d-flex mb-3">
      <h5 class="modal-title mb-0 fw-bolder" id="exampleModalLabel">
        Close Transaction
      </h5>
      <button
        type="button"
        class="closeBtn d-none"
        data-bs-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <img loading="lazy" src="assets/icons/close-icon.svg" alt="" />
      </button>
    </div>
    <div class="col-12 mb-3">
      <p>
        Are you sure you want to close transaction? Please note that this action
        cannot be undone.
      </p>
      <div class="d-flex align-items-center gap-2 mt-4">
        <button
          (click)="emitCloseConfirmation.emit(false); closeBtn.click()"
          class="submit-btn fw-700 font-13 btn-decline"
        >
          Cancel
        </button>
        <button
          class="submit-btn fw-700 font-13"
          (click)="emitCloseConfirmation.emit(true); closeBtn.click()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</swap-modal>
